import { QueryEncoder } from '@angular/http';

export class DataMinerQueryEncoder extends QueryEncoder {

    encodeKey(k: string): string {
        const encodedKey = super.encodeKey(k);

        return encodedKey.replace(/\+/gi, '%2B');
    }

    encodeValue(v: string): string {
        const encodedValue = super.encodeValue(v);

        return encodedValue.replace(/\+/gi, '%2B');
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/dataminer-query-encoder.ts